import React, { useRef, useState } from 'react'
import { MaterialDesignContent, SnackbarProvider } from 'notistack'
import ruLocale from 'date-fns/locale/ru'

import { styled, ThemeProvider } from '@material-ui/core/styles'
import { MuiPickersUtilsProvider } from '@material-ui/pickers'

import './App.css'

import { AppDialog } from './AppDialog'
import { AppContent } from './AppContent'
import { RuDateFnsUtils } from './RuDateFnsUtils'

import { Store } from '../store/store'
import { Logic } from '../store/logic/logic'
import { configureMobx } from '../store/mobxConfig'
import { AppContext, IAppContext } from '../store/appContext'

import { appTheme } from '../common/appTheme'

configureMobx()

export const App = () => {
  const snackbarRef = useRef<SnackbarProvider>(null)

  const [appContext] = useState<IAppContext>(() => {
    const store = new Store()

    return ({
      store,
      logic: new Logic(store, snackbarRef)
    })
  })

  return (
    <AppContext.Provider value={appContext}>
      <ThemeProvider theme={appTheme}>
        <MuiPickersUtilsProvider utils={RuDateFnsUtils} locale={ruLocale}>
          <SnackbarProvider
            hideIconVariant
            maxSnack={3}
            anchorOrigin={{vertical: 'bottom', horizontal: 'center'}}
            Components={{success: StyledMaterialDesignContent}}
            ref={snackbarRef}
          >
            <AppContent/>

            <AppDialog/>
          </SnackbarProvider>
        </MuiPickersUtilsProvider>
      </ThemeProvider>
    </AppContext.Provider>
  )
}

const StyledMaterialDesignContent = styled(MaterialDesignContent)(() => ({
  '&.notistack-MuiContent-success': {
    backgroundColor: '#61BD83'
  },
  '&.notistack-MuiContent-error': {
    backgroundColor: '#F5998C'
  },
  '&.notistack-MuiContent-warning': {
    backgroundColor: '#F0AD65'
  }
}))